module.exports = __webpack_public_path__ + "static/media/KM-MM-SSS-SAMATVAM-PROGRESS-REPORT-2018-2019.0830ff6a.pdf";